import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { PaginatedResponse } from '../../../../interfaces/PaginatedResponse';
import { MyOrder } from '../../../../interfaces/Order/MyOrder';
import { Pagination } from '../../../../interfaces/Pagination';
import { getMyOrders } from '../../../../api/Order';
import { bodyWidth } from '../../../../utils/Style';
import { AccountNavbar } from '../../AccountNavbar';
import { OrdersTable } from '../../../../components/Order/OrdersTable';
import { GenericHelmet } from '../../../../components/Helmet/GenericHelmet';

export const OrdersPage = () => {
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState<PaginatedResponse<MyOrder>>({
    data: [],
    totalCount: 0,
  });
  const [pagination, setPagination] = useState<Pagination>({
    page: 0,
    pageSize: 10,
  });

  const refreshOrders = () => {
    setLoading(true);
    getMyOrders(pagination)
      .then(setOrders)
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshOrders();
  }, [pagination]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet title='Sipariş Geçmişi' />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          pb: 3,
          px: 1.5,
          gap: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <AccountNavbar selectedTab='orders' />

        <Typography sx={{ fontSize: '1.75rem', fontWeight: 600 }}>
          Sipariş Geçmişi
        </Typography>

        <OrdersTable
          orders={orders.data}
          totalCount={orders.totalCount}
          pagination={pagination}
          onPagination={setPagination}
          loading={loading}
        />
      </Box>
    </Box>
  );
};
